// src/pages/BlogPost.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { wp } from "../lib/wp";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    fetch(wp(`/wp/v2/posts?slug=${slug}&_embed=1`))
      .then((r) => r.json())
      .then((arr) => setPost(Array.isArray(arr) && arr.length ? arr[0] : null))
      .catch(() => setPost(null));
  }, [slug]);

  if (!post) return <div className="p-6">Yükleniyor…</div>;

  return (
    <div className="bg-[#F8F6ED] min-h-screen py-10 px-4">
      <div className="max-w-3xl mx-auto">
        <h1
          className="text-3xl font-bold text-[#424197] mb-3"
          dangerouslySetInnerHTML={{ __html: post.title.rendered }}
        />
        <p className="text-sm text-gray-500 mb-8">
          <Link to="/blog" className="underline">
            Blog
          </Link>{" "}
          / {new Date(post.date).toLocaleDateString("tr-TR")}
        </p>

        <div
          className="prose max-w-none prose-img:rounded-lg prose-a:text-[#27285C] prose-a:underline"
          dangerouslySetInnerHTML={{ __html: post.content.rendered }}
        />
      </div>
    </div>
  );
};

export default BlogPost;
